import React from "react";
import DefaultHeader from "../../molecules/layout/Header/DefaultHeader";
import htmlDecode from "../../../utils/htmlDecode";
import PropTypes from "prop-types";

function DefaultRichTextPage(props) {
    return (
        <>
            <DefaultHeader>
                <h1 className="text-white">{props.title}</h1>
            </DefaultHeader>
            <div className="col-md-12 px-0 bg-soft-gray pt-lg-4 pb-lg-7">
                <div className="container pb-5 text-gray">
                    <div className="row justify-content-center">
                        <div className="col-lg-11 col-md-12">
                            <div className="card bg-gradient-white card-tile border border-soft mb-0 pt-4">
                                <div className="card-body px-lg-4 pb-lg-5 pt-lg-4">
                                    <div>
                                        <div
                                            className="rich-text"
                                            dangerouslySetInnerHTML={{
                                                __html: htmlDecode(
                                                    props.richText
                                                ),
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

DefaultRichTextPage.propTypes = {
    title: PropTypes.string.isRequired,
    richText: PropTypes.string.isRequired,
};

export default DefaultRichTextPage;
